const rawPublicAppUrl = import.meta.env.VITE_PUBLIC_APP_URL as string | undefined;
import type { ScoreCardHtmlTemplateId } from '../shared/scoreCardHtmlTemplates.js';

function normalizeBaseUrl(value: string): string {
  return value.trim().replace(/\/$/, '');
}

export function getPublicAppBaseUrl(): string {
  if (typeof rawPublicAppUrl === 'string' && rawPublicAppUrl.trim() !== '') {
    return normalizeBaseUrl(rawPublicAppUrl);
  }
  return normalizeBaseUrl(window.location.origin);
}

export function buildShareUrl(token: string, templateId?: ScoreCardHtmlTemplateId): string {
  const base = `${getPublicAppBaseUrl()}/share/${token}`;
  if (!templateId) return base;
  return `${base}?template=${encodeURIComponent(templateId)}`;
}
